import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import {  Row, Col } from 'react-bootstrap';
import DeptLeft from '../People/Dept_Left'

const GallaryImages = [
    {
        images: [
            "https://files.iittp.ac.in/pics/creche/1.jpg",
            "https://files.iittp.ac.in/pics/creche/2.jpg",
            "https://files.iittp.ac.in/pics/creche/3.jpg",
            "https://files.iittp.ac.in/pics/creche/4.jpg",
            "https://files.iittp.ac.in/pics/creche/5.jpg",
            "https://files.iittp.ac.in/pics/creche/2023/6.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/7.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/8.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/9.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/10.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/11.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/12.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/13.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/14.jpeg"
        ]
    }
];




function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Kendriya Vidyalaya" />
            <section className="team-area fix p-relative pt-120 pb-80" >
                 

                <div className="row">
                    <div className="col-lg-12 p-relative">
                        <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
               
                            <h3>Kendriya Vidyalaya @ IIT Tirupati Campus</h3>
                        </div>
                    </div>
                </div>
                <div className="container">
					<h4 className='c-headline  mb-3 mt-4'>Walk-in-interview for part-time contractual teacher posts for the session 2025-26</h4>

                    <Row>
                        <Col md={12} className='c-left custom-padding-color'>
						<ul className='ms-3 c-lineheight2dot5 iarrow' >

                        {/* <li className="glowing-text"><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> <b style={{ color: "blue" }}> <img src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="30" height="20" /> Provisionally selected list of candidates for appointment of Contractual Teachers for 2024-2025</b>&nbsp; : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Selected_List_2024-25.pdf" target="_blank" rel="noopener noreferrer"> 
                                    <b style={{ color: "blue" }}><u>Click here to view</u></b>
                                    </Link>
                                 </li> */}
                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><img src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="30" height="20" /> Advertisement for a walk-in-interview for part-time contractual teacher posts in KV School, IIT Tirupati campus : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2025/Advertisement_2025.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />General Instructions and Qualifications for walk-in-interviews : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2025/General_Instructions.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Bio Data Form 2025-26 for walk-in-interviews : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2025/Bio_Data_Form.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <div className="container">
					<h4 className='c-headline  mb-3 mt-4'>Notification for the position of Junior Executive Assistant - Admin for KV school</h4>

                    <Row>
                        <Col md={12} className='c-left custom-padding-color'>
						<ul className='ms-3 c-lineheight2dot5 iarrow' >

                       
                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />  Notification : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMRECT-OS202401_Notification.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Application Form : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMRECT-OS202401_Application_Form.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to download</u></b>
                                    </Link>
                                 </li>

                                 
                            </ul>
                        </Col>
                    </Row>
                </div>
                
                <div className="container">
					<h4 className='c-headline  mb-3 mt-4'>Admissions for the Vacant Seats for the Session 2024-2025</h4>

                    <Row>
                        <Col md={12} className='c-left custom-padding-color'>
						<ul className='ms-3 c-lineheight2dot5 iarrow' >

                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Registration Form 2024-2025 : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Registration_Form_2024-25_16_6_24.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to download</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />List of documents to be attached with Registration Form and Age Criteria : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/List_of_Documents_16_6_2024.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to download</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Advertisement for the Vacant Seats for the Session 2024-2025 : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Advertisement_16_6_24.jpg" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                {/* <div className="container">
					<h4 className='c-headline  mb-3 mt-4'>Walk-in-interview for part-time contractual teacher posts</h4>

                    <Row>
                        <Col md={12} className='c-left custom-padding-color'>
						<ul className='ms-3 c-lineheight2dot5 iarrow' >

                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Provisionally selected list of candidates for appointment of Contractual Teachers for 2024-2025 &nbsp; : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Selected_List_2024-25.pdf" target="_blank" rel="noopener noreferrer"> 
                                    <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>
                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Advertisement for a walk-in-interview for part-time contractual teacher posts in KV School, IIT Tirupati campus : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/KVIITTP_WalkinInterview.png" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />General Instructions and Qualifications for walk-in-interviews : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/General_Instructions_and_Qualifications_for_walk-in-interviews.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Bio Data Form 2024-25 for walk-in-interviews : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Bio_Data_Form_2024-25_fo_walk-in-interviews.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>
                            </ul>
                        </Col>
                    </Row>
                </div> */}

                <div className="container">
					<h4 className='c-headline  mb-3 mt-4'>Admissions for the Academic Session 2024-25</h4>

                    <Row>
                        <Col md={12} className='c-left custom-padding-color'>
						<ul className='ms-3 c-lineheight2dot5 iarrow' >

                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Provisionally Selected List of Candidates for Admissions during 2024-2025 : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Provisionally_Selected_List_of_Candidates_for_Admissions_during_2024-25.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Fee Structure for the Year 2024-2025 : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Fee_Structure_for_the_Year_2024-25.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Fee Payment Account Details : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Fee_Payment_Account_Details.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> List of documents to be produced for verification at the time of Admission : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/List_of_documents_to_be_produced_for_verification_at_the_time_of_Admission_Updated.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Admission Guidelines 2024-2025 : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Admission_Guidelines_2024-25.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here to view</u></b>
                                    </Link>
                                 </li>

                                <li className='mt-3'><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Registration Form 2024-2025 : &nbsp;&nbsp;
                                
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/Registration_Form_2024-25.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u> Click here to download</u> </b>
                                    </Link>
                                </li>

                                <li className='mt-3'><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> List of documents to be attached with Registration Form and Age Criteria : &nbsp;&nbsp; 
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/List_of_documents_to_be_attached_with_Registration_Form_20-4-2024.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u> Click here to download</u> </b>
                                    </Link>
                                </li>
                                <li className='mt-3'><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Advertisement for Admissions 2024-2025 : &nbsp;&nbsp; 
                                    <Link to="https://files.iittp.ac.in/pdfs/kvsiittcampus/2024/ADV_KVS_IITT_2024.png" target="_blank" rel="noopener noreferrer"> 
                                        <b><u> Click here to view</u> </b>
                                    </Link>
                                </li>
                                
                            </ul>
                          
                        </Col>
                      
                    </Row>
                </div>

            </section>
        </>
    )
}


export default Main;